// Components, Layouts, Pages
import {
  EmployeePageAdmin,
  JobPageAdmin,
  FormContactPageAdmin,
  TaskPageAdmin,
  SettingsPageAdmin,
  IntegrationPageAdmin,
  InvoicePageAdmin,
} from '~/pages/admin';
import {
  SchedulePageTemplate,
  ContactDetailPage,
  CustomerDetailTemplate,
  JobDetailTemplate,
  FormCustomerTemplate,
  CustomerPageTemplate,
  FormEmployeeTemplate,
  EmployeeDetailTemplate,
  FormTaskTemplate,
  CategoryPageTemplate,
  ServicePageTemplate,
  MaterialPageTemplate,
  FormServiceTemplate,
  FormMaterialTemplate,
  FormPriceBookTemplate,
  ServiceDetailTemplate,
  TaskDetailPageTemplate,
  MaterialDetailTemplate,
  PriceBookDetailTemplate,
  MessagePageTemplate,
  TimeClockPageTemplate,
  TimeClockDetailTemplate,
  DashboardPageTemplate,
  EstimatePageTemplate,
  FormEstimateTemplate,
  MarketingPageTemplate,
  CampaignPageTemplate,
  FormCampaignTemplate,
  CampaignDetailTemplate,
  EstimateDetailTemplate,
  FormJobTemplate,
  ProfileTemplate,
  InvoiceDetailTemplate,
  ReportPageTemplate,
  SubReviewPageTemplate,
  GmailPageTemplate,
  ReportTechnicianPageTemplate,
  ReportSaleByCityPageTemplate,
  ReportServiceVolumePageTemplate,
  ReportPerCallAveragePageTemplate,
  ReportPoPerPayPeriodPageTemplate,
} from '~/pages/template';
// Others
import { MenuNameEnum } from '~/utils/enum/common';
import { IRouteModel } from '~/utils/interface/base';
// Styles, images, icons
import { icons } from '~/assets';

export const adminRoute = {
  base: '/admin',
  employees: '/employees',
  customers: '/customers',
  customerDetail: '/customers/:id',
  schedule: '/schedule',
  crm: '/crm',
  inventory: '/inventory',
  services: '/services',
  materials: '/materials',
  estimateTemplate: '/estimate-template',
  priceBooks: '/price-books',
  contacts: '/contacts',
  pipeline: '/pipeline',
  jobs: '/jobs',
  tasks: '/tasks',
  estimate: '/estimate',
  timeClock: '/time-clocks',
  payroll: '/payroll',
  marketing: '/marketing',
  campaigns: '/campaigns',
  reports: '/reports',
  technicianReport: '/technician',
  saleByCityReport: '/sale-by-city',
  serviceVolumeReport: '/service-volume',
  perCallAverageReport: '/per-call-average',
  poPerPayPeriodReport: '/po-per-pay-period',
  settings: '/settings',
  integration: '/integration',
  message: '/message',
  profile: '/profile',
  invoice: '/invoice',
  category: '/category',
  tags: '/tags',
  leadSource: '/lead-source',
  review: '/review',
  gmail: '/gmail',

  // Common
  commonCreate: '/create',
  commonEdit: '/edit',
  commonDetail: '/:id',
};

export const privateAdminRoutes: IRouteModel[] = [
  {
    index: true,
    path: `${adminRoute.base}`,
    component: DashboardPageTemplate,
    name: MenuNameEnum.DASHBOARD,
    icon: icons.menuIconDashboardInactive,
    activeIcon: icons.menuIconDashboardActive,
  },
  {
    path: `${adminRoute.base}${adminRoute.employees}`,
    component: EmployeePageAdmin,
    name: MenuNameEnum.EMPLOYEES,
    icon: icons.menuIconEmployeesInactive,
    activeIcon: icons.menuIconEmployeesActive,
  },
  {
    path: `${adminRoute.base}${adminRoute.employees}${adminRoute.commonCreate}`,
    component: FormEmployeeTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.employees}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
    component: FormEmployeeTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.employees}${adminRoute.commonDetail}`,
    component: EmployeeDetailTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.customers}`,

    component: CustomerPageTemplate,
    name: MenuNameEnum.CUSTOMERS,
    icon: icons.menuIconCustomersInactive,
    activeIcon: icons.menuIconCustomersActive,
  },
  {
    path: `${adminRoute.base}${adminRoute.customers}${adminRoute.commonCreate}`,
    component: FormCustomerTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.customers}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
    component: FormCustomerTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.customers}${adminRoute.commonDetail}`,
    name: MenuNameEnum.CUSTOMER_DETAIL,
    component: CustomerDetailTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.schedule}`,
    component: SchedulePageTemplate,
    name: MenuNameEnum.SCHEDULE,
    icon: icons.menuIconScheduleInactive,
    activeIcon: icons.menuIconScheduleActive,
  },
  // {
  //   path: `${adminRoute.base}${adminRoute.crm}`,
  //   component: CrmPageAdmin,
  //   name: MenuNameEnum.CRM,
  //   icon: icons.menuIconCRMInactive,
  //   activeIcon: icons.menuIconCRMActive,
  //   children: [
  //     {
  //       path: `${adminRoute.base}${adminRoute.crm}${adminRoute.contacts}`,
  //       component: ContactPageAdmin,
  //       name: MenuNameEnum.CONTACTS,
  //     },
  //     {
  //       path: `${adminRoute.base}${adminRoute.crm}${adminRoute.pipeline}`,
  //       component: PipelineTemplate,
  //       name: MenuNameEnum.PIPELINE,
  //     },
  //   ],
  // },
  {
    path: `${adminRoute.base}${adminRoute.crm}${adminRoute.contacts}${adminRoute.commonCreate}`,
    component: FormContactPageAdmin,
  },
  {
    path: `${adminRoute.base}${adminRoute.crm}${adminRoute.contacts}${adminRoute.commonDetail}`,
    name: MenuNameEnum.CONTACT_DETAIL,
    component: ContactDetailPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.crm}${adminRoute.contacts}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
    component: FormContactPageAdmin,
  },
  {
    path: `${adminRoute.base}${adminRoute.inventory}`,
    component: CategoryPageTemplate,
    name: MenuNameEnum.INVENTORY,
    icon: icons.menuIconCategoryInactive,
    activeIcon: icons.menuIconCategoryActive,
    children: [
      {
        path: `${adminRoute.base}${adminRoute.inventory}${adminRoute.services}`,
        component: ServicePageTemplate,
        name: MenuNameEnum.SERVICES,
      },
      {
        path: `${adminRoute.base}${adminRoute.inventory}${adminRoute.materials}`,
        component: MaterialPageTemplate,
        name: MenuNameEnum.MATERIALS,
      },
      // {
      //   path: `${adminRoute.base}${adminRoute.inventory}${adminRoute.estimateTemplate}`,
      //   component: EstimateTemplatePageTemplate,
      //   name: MenuNameEnum.ESTIMATE_TEMPLATE,
      // },
    ],
  },
  // {
  //   path: `${adminRoute.base}${adminRoute.inventory}${adminRoute.estimateTemplate}${adminRoute.commonCreate}`,
  //   component: FormTemplateEstimateTemplate,
  // },
  // {
  //   path: `${adminRoute.base}${adminRoute.inventory}${adminRoute.estimateTemplate}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
  //   component: FormTemplateEstimateTemplate,
  // },
  {
    path: `${adminRoute.base}${adminRoute.inventory}${adminRoute.materials}${adminRoute.commonDetail}`,
    component: MaterialDetailTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.inventory}${adminRoute.services}${adminRoute.commonCreate}`,
    component: FormServiceTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.inventory}${adminRoute.services}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
    component: FormServiceTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.inventory}${adminRoute.services}${adminRoute.commonDetail}`,
    name: MenuNameEnum.SERVICE_DETAIL,
    component: ServiceDetailTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.inventory}${adminRoute.materials}${adminRoute.commonCreate}`,
    component: FormMaterialTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.inventory}${adminRoute.materials}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
    component: FormMaterialTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.jobs}`,
    component: JobPageAdmin,
    name: MenuNameEnum.JOBS,
    icon: icons.menuIconJobsInactive,
    activeIcon: icons.menuIconJobsActive,
  },
  {
    path: `${adminRoute.base}${adminRoute.jobs}${adminRoute.commonCreate}`,
    component: FormJobTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.jobs}${adminRoute.commonDetail}`,
    name: MenuNameEnum.JOBS_DETAIL,
    component: JobDetailTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.jobs}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
    component: FormJobTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.tasks}`,
    component: TaskPageAdmin,
    name: MenuNameEnum.TASKS,
    icon: icons.menuIconTasksInactive,
    activeIcon: icons.menuIconTasksActive,
  },
  {
    path: `${adminRoute.base}${adminRoute.tasks}${adminRoute.commonCreate}`,
    component: FormTaskTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.tasks}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
    component: FormTaskTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.tasks}${adminRoute.commonDetail}`,
    component: TaskDetailPageTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.estimate}`,
    component: EstimatePageTemplate,
    name: MenuNameEnum.ESTIMATE,
    icon: icons.menuIconEstimateInactive,
    activeIcon: icons.menuIconEstimateActive,
  },
  {
    path: `${adminRoute.base}${adminRoute.estimate}${adminRoute.commonCreate}`,
    component: FormEstimateTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.estimate}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
    component: FormEstimateTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.estimate}${adminRoute.commonDetail}`,
    component: EstimateDetailTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.invoice}`,
    component: InvoicePageAdmin,
    name: MenuNameEnum.INVOICE,
    icon: icons.menuIconInvoiceInactive,
    activeIcon: icons.menuIconInvoiceActive,
  },
  {
    path: `${adminRoute.base}${adminRoute.invoice}${adminRoute.commonDetail}`,
    component: InvoiceDetailTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.timeClock}`,
    component: TimeClockPageTemplate,
    name: MenuNameEnum.TIME_CLOCK,
    icon: icons.menuIconTimeClockInactive,
    activeIcon: icons.menuIconTimeClockActive,
  },
  {
    path: `${adminRoute.base}${adminRoute.timeClock}${adminRoute.commonDetail}`,
    component: TimeClockDetailTemplate,
  },
  // {
  //   path: `${adminRoute.base}${adminRoute.payroll}`,
  //   component: PayrollPageAdmin,
  //   name: MenuNameEnum.PAYROLL,
  //   icon: icons.menuIconPayrollInactive,
  //   activeIcon: icons.menuIconPayrollActive,
  // },
  {
    path: `${adminRoute.base}${adminRoute.marketing}`,
    component: MarketingPageTemplate,
    name: MenuNameEnum.MARKETING,
    icon: icons.menuIconMarketingInactive,
    activeIcon: icons.menuIconMarketingActive,
    children: [
      {
        path: `${adminRoute.base}${adminRoute.marketing}${adminRoute.campaigns}`,
        component: CampaignPageTemplate,
        name: MenuNameEnum.CAMPAIGNS,
      },
    ],
  },
  {
    path: `${adminRoute.base}${adminRoute.marketing}${adminRoute.campaigns}${adminRoute.commonCreate}`,
    component: FormCampaignTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.marketing}${adminRoute.campaigns}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
    component: FormCampaignTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.marketing}${adminRoute.campaigns}${adminRoute.commonDetail}`,
    component: CampaignDetailTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.review}`,
    component: SubReviewPageTemplate,
    name: MenuNameEnum.REVIEW,
    icon: icons.MenuIconReviewInactive,
    activeIcon: icons.MenuIconReviewActive,
    // children: [
    //   {
    //     path: `${adminRoute.base}${adminRoute.review}`,
    //     component: SubReviewPageTemplate,
    //     name: MenuNameEnum.REVIEW,
    //   },
    // ],
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}`,
    component: ReportPageTemplate,
    name: MenuNameEnum.REPORTS,
    icon: icons.menuIconReportsInactive,
    activeIcon: icons.menuIconReportsActive,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.technicianReport}`,
    component: ReportTechnicianPageTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.saleByCityReport}`,
    component: ReportSaleByCityPageTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.serviceVolumeReport}`,
    component: ReportServiceVolumePageTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.perCallAverageReport}`,
    component: ReportPerCallAveragePageTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.poPerPayPeriodReport}`,
    component: ReportPoPerPayPeriodPageTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.settings}`,
    component: SettingsPageAdmin,
    name: MenuNameEnum.SETTINGS,
    icon: icons.menuIconSettingsInactive,
    activeIcon: icons.menuIconSettingsActive,
    children: [
      {
        path: `${adminRoute.base}${adminRoute.settings}${adminRoute.integration}`,
        component: IntegrationPageAdmin,
        name: MenuNameEnum.INTEGRATION,
      },
      // {
      //   path: `${adminRoute.base}${adminRoute.settings}${adminRoute.tags}`,
      //   component: TagsPageAdmin,
      //   name: MenuNameEnum.TAGS,
      // },
      // {
      //   path: `${adminRoute.base}${adminRoute.settings}${adminRoute.category}`,
      //   component: CategoryPageAdmin,
      //   name: MenuNameEnum.CATEGORY,
      // },
      // {
      //   path: `${adminRoute.base}${adminRoute.settings}${adminRoute.leadSource}`,
      //   component: LeadSourcePageAdmin,
      //   name: MenuNameEnum.LEAD_SOURCE,
      // },
      // {
      //   path: `${adminRoute.base}${adminRoute.settings}${adminRoute.priceBooks}`,
      //   component: PriceBookTemplate,
      //   name: MenuNameEnum.PRICE_BOOKS,
      // },
    ],
  },
  {
    path: `${adminRoute.base}${adminRoute.settings}${adminRoute.priceBooks}${adminRoute.commonCreate}`,
    component: FormPriceBookTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.settings}${adminRoute.priceBooks}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
    component: FormPriceBookTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.settings}${adminRoute.priceBooks}${adminRoute.commonDetail}`,
    component: PriceBookDetailTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.message}`,
    component: MessagePageTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.profile}`,
    component: ProfileTemplate,
  },
  {
    path: `${adminRoute.base}${adminRoute.gmail}`,
    component: GmailPageTemplate,
  },
];

export const adminRouteAbsolute = {
  dashboard: `${adminRoute.base}`,
  customers: `${adminRoute.base}${adminRoute.customers}`,
  schedules: `${adminRoute.base}${adminRoute.schedule}`,
  contacts: `${adminRoute.base}${adminRoute.crm}${adminRoute.contacts}`,
  employees: `${adminRoute.base}${adminRoute.employees}`,
  createEmployee: `${adminRoute.base}${adminRoute.employees}${adminRoute.commonCreate}`,
  updateEmployee: (employeeId: string) =>
    `${adminRoute.base}${adminRoute.employees}/${employeeId}${adminRoute.commonEdit}`,
  createCustomer: `${adminRoute.base}${adminRoute.customers}${adminRoute.commonCreate}`,
  editCustomer: (customerId: string) =>
    `${adminRoute.base}${adminRoute.customers}/${customerId}${adminRoute.commonEdit}`,
  jobs: `${adminRoute.base}${adminRoute.jobs}`,
  createJob: `${adminRoute.base}${adminRoute.jobs}${adminRoute.commonCreate}`,
  createContact: `${adminRoute.base}${adminRoute.crm}${adminRoute.contacts}${adminRoute.commonCreate}`,
  updateContact: (contactId: string) =>
    `${adminRoute.base}${adminRoute.crm}${adminRoute.contacts}/${contactId}${adminRoute.commonEdit}`,
  updateJob: (jobId: string) => `${adminRoute.base}${adminRoute.jobs}/${jobId}${adminRoute.commonEdit}`,
  tasks: `${adminRoute.base}${adminRoute.tasks}`,
  createTask: `${adminRoute.base}${adminRoute.tasks}${adminRoute.commonCreate}`,
  updateTask: (taskId: string) => `${adminRoute.base}${adminRoute.tasks}/${taskId}${adminRoute.commonEdit}`,
  service: `${adminRoute.base}${adminRoute.inventory}${adminRoute.services}`,
  createService: `${adminRoute.base}${adminRoute.inventory}${adminRoute.services}${adminRoute.commonCreate}`,
  updateService: (serviceId: string) =>
    `${adminRoute.base}${adminRoute.inventory}${adminRoute.services}/${serviceId}${adminRoute.commonEdit}`,
  materials: `${adminRoute.base}${adminRoute.inventory}${adminRoute.materials}`,
  createMaterial: `${adminRoute.base}${adminRoute.inventory}${adminRoute.materials}${adminRoute.commonCreate}`,
  updateMaterial: (materialId: string) =>
    `${adminRoute.base}${adminRoute.inventory}${adminRoute.materials}/${materialId}${adminRoute.commonEdit}`,
  priceBooks: `${adminRoute.base}${adminRoute.settings}${adminRoute.priceBooks}`,
  createPriceBook: `${adminRoute.base}${adminRoute.settings}${adminRoute.priceBooks}${adminRoute.commonCreate}`,
  updatePriceBook: (priceBookId: string) =>
    `${adminRoute.base}${adminRoute.settings}${adminRoute.priceBooks}/${priceBookId}${adminRoute.commonEdit}`,
  message: `${adminRoute.base}${adminRoute.message}`,
  timeClock: `${adminRoute.base}${adminRoute.timeClock}`,
  estimate: `${adminRoute.base}${adminRoute.estimate}`,
  createEstimate: `${adminRoute.base}${adminRoute.estimate}${adminRoute.commonCreate}`,
  createEstimateTemplate: `${adminRoute.base}${adminRoute.inventory}${adminRoute.estimateTemplate}${adminRoute.commonCreate}`,
  updateEstimateTemplate: (templateId: string) =>
    `${adminRoute.base}${adminRoute.inventory}${adminRoute.estimateTemplate}/${templateId}${adminRoute.commonEdit}`,
  createCampaign: `${adminRoute.base}${adminRoute.marketing}${adminRoute.campaigns}${adminRoute.commonCreate}`,
  updateCampaign: (campaignId: string) =>
    `${adminRoute.base}${adminRoute.marketing}${adminRoute.campaigns}/${campaignId}${adminRoute.commonEdit}`,
  updateEstimate: (estimateId: string) =>
    `${adminRoute.base}${adminRoute.estimate}/${estimateId}${adminRoute.commonEdit}`,
  profile: `${adminRoute.base}${adminRoute.profile}`,
  invoice: `${adminRoute.base}${adminRoute.invoice}`,
  gmail: `${adminRoute.base}${adminRoute.gmail}`,
  technicianReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.technicianReport}`,
  saleByCityReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.saleByCityReport}`,
  serviceVolumeReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.serviceVolumeReport}`,
  perCallAverageReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.perCallAverageReport}`,
  poPerPayPeriodReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.poPerPayPeriodReport}`,
  settings: `${adminRoute.base}${adminRoute.settings}`,
};
